module.exports = __webpack_public_path__ + "static/media/github-logo.76d344f0.svg";